const enum WORK_OUT {
  AT_HOME = "At Home",
  AT_THE_GYM = "At the gym",
  OUTDOOR = "Outdoor",
  ANT_PLACE_IS_OK = "Any place is ok",
}

export default WORK_OUT;
